import React, { useEffect, useState } from 'react';
import axios from 'axios';

const statusOptions = ['Pending', 'Approved', 'Rejected', 'Cancelled', 'Returned'];

const AdminRentalOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [updatingId, setUpdatingId] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      setError('');
      const token = localStorage.getItem('token');
      try {
        const res = await axios.get('/api/products/rentals/orders/all', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setOrders(res.data);
      } catch (err) {
        setError('Failed to load rental orders.');
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  const handleStatusChange = async (orderId, status) => {
    setUpdatingId(orderId);
    const token = localStorage.getItem('token');
    try {
      await axios.put(`/api/products/rentals/orders/${orderId}/status`, { status }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrders((prev) => prev.map(o => o._id === orderId ? { ...o, status } : o));
    } catch (err) {
      alert('Failed to update status');
    } finally {
      setUpdatingId(null);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <h1 className="text-3xl font-bold mb-8 text-primary">All Rental Orders</h1>
      {loading ? (
        <div className="text-center text-lg">Loading...</div>
      ) : error ? (
        <div className="text-center text-red-500">{error}</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white rounded-lg shadow-md">
            <thead>
              <tr className="bg-gray-100 text-gray-700">
                <th className="py-2 px-4">Product</th>
                <th className="py-2 px-4">Renter</th>
                <th className="py-2 px-4">Owner</th>
                <th className="py-2 px-4">Period</th>
                <th className="py-2 px-4">Total</th>
                <th className="py-2 px-4">Status</th>
                <th className="py-2 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.filter(order => order.isCustomBooking).map(order => (
                <tr key={order._id} className="border-b hover:bg-gray-50">
                  <td className="py-2 px-4 flex items-center gap-2">
                    <img src={order.rentalProduct?.images?.[0] || '/logo.png'} alt={order.rentalProduct?.name} className="w-12 h-12 object-cover rounded" />
                    <span>{order.rentalProduct?.name}</span>
                  </td>
                  <td className="py-2 px-4">{order.renter?.name || 'N/A'}</td>
                  <td className="py-2 px-4">{order.owner?.name || 'N/A'}</td>
                  <td className="py-2 px-4">{new Date(order.rentalPeriod.startDate).toLocaleDateString()}<br/>to<br/>{new Date(order.rentalPeriod.endDate).toLocaleDateString()}</td>
                  <td className="py-2 px-4 font-bold text-pink-600">₹{order.total}</td>
                  <td className="py-2 px-4">
                    <span className={`font-semibold ${order.status === 'Approved' ? 'text-green-600' : order.status === 'Rejected' ? 'text-red-600' : order.status === 'Returned' ? 'text-blue-600' : order.status === 'Cancelled' ? 'text-gray-600' : 'text-yellow-600'}`}>{order.status}</span>
                  </td>
                  <td className="py-2 px-4">
                    <div className="flex flex-col gap-1">
                      {statusOptions.map(opt => (
                        <button
                          key={opt}
                          className={`px-3 py-1 rounded text-xs font-semibold ${order.status === opt ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700 hover:bg-primary hover:text-white'} transition`}
                          onClick={() => handleStatusChange(order._id, opt)}
                          disabled={updatingId === order._id || order.status === opt}
                        >
                          {updatingId === order._id && order.status !== opt ? 'Updating...' : opt}
                        </button>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminRentalOrders; 